import React from "react";
import { Button, Row, Col } from "react-bootstrap";
import { useFormikContext, FieldArray } from "formik";
import { PlusCircle, CreditCard, Wallet, Landmark, Banknote } from "lucide-react";
import PaymentMethodRefined from "./PaymentMethodRefined";

const PaymentMethodsField = () => {
  const { values, setFieldValue } = useFormikContext();
  const methods = values.payment_methods || [];

  const handleAddPaymentMethod = (push) => {
    push({ method: "Cash", amount: 0, details: {} });
  };

  return (
    <div className="erp-methods-container">
      <style>
        {`
            .add-method-btn {
                background: #f1f5f9;
                border: 2px dashed #cbd5e1;
                color: #64748b;
                border-radius: 16px;
                padding: 15px;
                width: 100%;
                font-weight: 800;
                text-transform: uppercase;
                letter-spacing: 1px;
                font-size: 11px;
                transition: all 0.2s;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
            }
            .add-method-btn:hover {
                background: #e2e8f0;
                color: #001c3a;
                border-color: #001c3a;
            }
        `}
      </style>

      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="d-flex align-items-center gap-2">
          <CreditCard size={18} className="text-primary" />
          <h6 className="mb-0 fw-900 text-dark uppercase letter-spacing-1">Financial Method Allocation</h6>
        </div>
      </div>

      <FieldArray name="payment_methods">
        {({ push, remove }) => (
          <Row className="g-3">
            {methods.map((_, index) => (
              <Col lg={12} key={index}>
                <PaymentMethodRefined index={index} remove={remove} />
              </Col>
            ))}
            <Col lg={12}>
              <button
                type="button"
                className="add-method-btn"
                onClick={() => handleAddPaymentMethod(push)}
              >
                <PlusCircle size={16} /> Add Split Method
              </button>
            </Col>
          </Row>
        )}
      </FieldArray>
    </div>
  );
};

export default PaymentMethodsField;
